import { ifAuthenticated } from '@/router/before'

export const journalsRouteNames = {
  JournalsListRoute: 'JournalsListRoute',
  JournalsCheckRoute: 'JournalsCheckRoute'
}
const rn = journalsRouteNames

export const journalsRouteURLs = {
  [rn.JournalsListRoute]: '/journals/list',
  [rn.JournalsCheckRoute]: '/journals/check'
}

export const journalsPages = [
  {
    path: journalsRouteURLs[rn.JournalsListRoute],
    name: rn.JournalsListRoute,
    meta: {
      sidebar: {
        icon: ['fa', 'book'],
        isDisplay: true
      },
      navbar: {
        group: 'Источники',
        displayName: 'Список источников'
      }
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "JournalsListRoute" */ '@/views/journals/JournalsListRoute.vue'
      )
  },
  {
    path: journalsRouteURLs[rn.JournalsCheckRoute],
    name: rn.JournalsCheckRoute,
    meta: {
      sidebar: {
        icon: ['fa', 'book-dead'],
        isDisplay: true
      },
      navbar: {
        group: 'Источники',
        displayName: 'Проверка источников'
      }
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "JournalsCheckRoute" */ '@/views/journals/JournalsCheckRoute.vue'
      )
  }
]
